import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "inicio", label: "Inicio" },
    { id: "servicios", label: "Servicios" },
    { id: "nosotros", label: "Nosotros" },
    { id: "filosofia", label: "Misión y Visión" },
    { id: "contacto", label: "Contacto" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-navy/70 backdrop-blur-xl" data-testid="main-navbar">
            <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-6 md:px-12">
                <button
                    onClick={() => go("inicio")}
                    className="flex items-center gap-3"
                    data-testid="nav-logo"
                >
                    <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border border-gold/60 bg-white">
                        <img src="/logo.jpg" alt="Logo AS Consulting S.A.S." className="h-full w-full object-contain" />
                    </span>
                    <span className="hidden flex-col leading-tight sm:flex">
                        <span className="font-display text-base font-semibold tracking-tight">AS Consulting</span>
                        <span className="text-[10px] uppercase tracking-[0.25em] text-[#9CA3AF]">S.A.S.</span>
                    </span>
                </button>

                <nav className="hidden items-center gap-7 md:flex lg:gap-10" data-testid="nav-links">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            onClick={() => go(l.id)}
                            className="text-[11px] uppercase tracking-[0.22em] text-[#F8F9FA]/70 transition-colors duration-300 hover:text-gold"
                            data-testid={`nav-link-${l.id}`}
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        onClick={() => go("contacto")}
                        className="border border-gold px-6 py-2.5 text-[11px] uppercase tracking-[0.22em] text-gold transition-colors duration-300 hover:bg-gold hover:text-navy"
                        data-testid="nav-cta-button"
                    >
                        Solicitar asesoría
                    </button>
                </nav>

                <button
                    className="text-[#F8F9FA] md:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Abrir menú"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div className="border-t border-white/10 bg-navy-deep px-6 py-8 md:hidden" data-testid="nav-mobile-menu">
                    <div className="flex flex-col gap-6">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                onClick={() => go(l.id)}
                                className="text-left font-display text-2xl text-[#F8F9FA]"
                                data-testid={`nav-mobile-link-${l.id}`}
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            onClick={() => go("contacto")}
                            className="mt-2 border border-gold px-6 py-3 text-center text-[11px] uppercase tracking-[0.22em] text-gold"
                            data-testid="nav-mobile-cta-button"
                        >
                            Solicitar asesoría
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
